<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0">
      <div class="title-font-style">
        <span>退货信息</span>
      </div>
      <el-form class="inner-from">
        <el-form-item label="售后类型：">退货</el-form-item>
        <el-form-item label="退货说明：" label-width="84px" :rules="filter_rules({required:true})">
          <el-input type="textarea" :rows="4" v-model="mask"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="box-content-title">
      <div class="title-font-style">
        <span>退货清单</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">全部产品</div>
            <el-table
              border
              ref="leftTableRef"
              :data="list"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              height="432px"
              @row-click="onRowClickL"
              @selection-change="handleSelectionChangeL"
            >
              <template slot="empty">
                <no-data :nodata="`nodataPurchase`">产品已全部移入退货区！</no-data>
              </template>
              <el-table-column fixed type="selection" :disabled="true" :selectable="selectableFun" width="45"></el-table-column>
              <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
              <el-table-column label="型号" prop="proType" show-overflow-tooltip></el-table-column>
              <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
              <el-table-column label="备货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
              </el-table-column>
              <el-table-column label="发货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
              </el-table-column>
              <el-table-column label="开票状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.invoiceState|invoiceStateFilter}}</template>
              </el-table-column>
              <el-table-column label="数量" prop="count"></el-table-column>
              <el-table-column label="销售单价">
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="onImmigration(1)">移入仓库退货区</el-button>
              <el-button @click="onImmigration(2)">移入供应商退货区</el-button>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">仓库退货区</div>
            <el-table
              border
              ref="topTableRef"
              :data="warehouseList"
              tooltip-effect="dark"
              height="180"
              :header-cell-style="tableHeader"
              @row-click="onRowClickT"
              @selection-change="handleSelectionChangeT"
            >
              <template slot="empty">
                <no-data :nodata="`nodataPurchase`">请选择退货产品！</no-data>
              </template>
              <el-table-column fixed type="selection" width="45"></el-table-column>
              <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
              <el-table-column label="型号" prop="proType" show-overflow-tooltip></el-table-column>
              <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
              <el-table-column label="备货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
              </el-table-column>
              <el-table-column label="发货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
              </el-table-column>
              <el-table-column label="开票状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.invoiceState|invoiceStateFilter}}</template>
              </el-table-column>
              <el-table-column label="产品序列号" width="100px">
                <template slot-scope="scope">
                  <el-button
                    v-show="scope.row.deliverState===3"
                    @click="onEntering(scope.row, scope.$index,1)"
                    type="text"
                    plain
                  >{{scope.row.proSerialNumber?'编辑':'点击录入'}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="125">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changeNumberW(scope.row)"
                    style="width:100%"
                    controls-position="right"
                    v-model="scope.row.count"
                    :min="1"
                    :max="scope.row.max"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="销售单价">
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column label="罚没单价" width="110px">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changeProice(scope.row)"
                    style="width:100%"
                    :controls="false"
                    v-model="scope.row.forfeitureProice"
                    :min="0"
                    :precision="2"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="罚没比例" width="110px">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changePenalty(scope.row)"
                    style="width: calc(100% - 20px)"
                    :controls="false"
                    v-model="scope.row.forfeiturePenalty"
                    :min="0"
                    :precision="2"
                  ></el-input-number>%
                </template>
              </el-table-column>
            </el-table>
            <div class="table-title" style="margin-top:30px">供应商退货区</div>
            <el-table
              border
              ref="bottomTableRef"
              :data="supplierList"
              height="180"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              @row-click="onRowClickB"
              @selection-change="handleSelectionChangeB"
            >
              <template slot="empty">
                <no-data :nodata="`nodataPurchase`">请选择退货产品！</no-data>
              </template>
              <el-table-column fixed type="selection" width="45"></el-table-column>
              <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
              <el-table-column label="型号" prop="proType" show-overflow-tooltip></el-table-column>
              <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
              <el-table-column label="备货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
              </el-table-column>
              <el-table-column label="发货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
              </el-table-column>
              <el-table-column label="开票状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.invoiceState|invoiceStateFilter}}</template>
              </el-table-column>
              <el-table-column label="产品序列号" width="100px" prop="proSerialNumber">
                <template slot-scope="scope">
                  <el-button
                    @click="onEntering(scope.row, scope.$index,2)"
                    type="text"
                    plain
                  >{{scope.row.proSerialNumber?'编辑':'点击录入'}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="125">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changeNumberS(scope.row)"
                    style="width:100%"
                    controls-position="right"
                    v-model="scope.row.count"
                    :min="1"
                    :max="scope.row.max"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="销售单价">
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column label="罚没单价" width="110px">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changeProice(scope.row)"
                    style="width:100%"
                    :controls="false"
                    v-model="scope.row.forfeitureProice"
                    :min="0"
                    :precision="2"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="罚没比例" width="110px">
                <template slot-scope="scope">
                  <el-input-number
                    @change="changePenalty(scope.row)"
                    style="width: calc(100% - 20px)"
                    :controls="false"
                    :min="0"
                    v-model="scope.row.forfeiturePenalty"
                    :precision="2"
                  ></el-input-number>%
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="onRemove">移出退货区</el-button>
              <el-button @click="onExport">导出全部序列号</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button
      @click="onApplyForMaintain"
      type="primary"
      :disabled="warehouseList.length===0&&supplierList.length===0"
    >申请退货</el-button>
    <div style="margin-top:14px; color:#D35E5E">提示：备货状态为待备货和已备货的产品才可以进行退货。</div>

    <!-------------- 录入产品序列号 ------------>
    <inprouct-serial-code-dialog @inProuctSerial="inProuctSerial" ref="inProuctSerialCodeRefs"></inprouct-serial-code-dialog>
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="申请退货"
      content="请再次确认退货申请，申请后对应商品不再允许发起相关开票、备货及发货请求。"
    ></open-or-close>
  </div>
</template>
<script>
import {
  queryReturnGoodList,
  applyForReturn,
  exportSerializableNumber
} from '@/api/sell/sellManage'
import noData from '@/components/module/noData'
import inProuctSerialCodeDialog from '@/views/purchase/purchaseManage/dialog/inProuctSerialCodeDialog' // 序列号
import OpenOrClose from '@/components/OpenOrClose/index'
import { downLoadFileBlob } from '@/util/tool'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'inprouct-serial-code-dialog': inProuctSerialCodeDialog,
    noData
  },
  data() {
    return {
      typeArr: 0, // 录入序列号的数组
      mask: '',
      list: [],
      forfeiturePenaltys: 0, // 默认罚没比例
      warehouseList: [], // 仓库
      supplierList: [], // 供应商
      tempList: [],
      tempSupplierList: [],
      tempWarehouseList: [],
      title: '', // 确认申请退票提示语
      content: '' // 确认申请退票内容
    }
  },
  watch: {
    list: {
      handler(newVal) {
        if (newVal) {
          const { warehouseList, supplierList } = this
          newVal.forEach((ele) => {
            const topIn = warehouseList.findIndex((m) => m.id === ele.id)
            const botIn = supplierList.findIndex((m) => m.id === ele.id)
            if (topIn !== -1 && botIn !== -1) {
              warehouseList[topIn].max = ele.maxs - supplierList[botIn].count
              supplierList[botIn].max = ele.maxs - warehouseList[topIn].count
            } else if (topIn !== -1 || botIn !== -1) {
              if (botIn === -1) {
                warehouseList[topIn].max = ele.maxs
              }
              if (topIn === -1) {
                supplierList[botIn].max = ele.maxs
              }
            }
          })
          this.warehouseList = JSON.parse(JSON.stringify(warehouseList))
          this.supplierList = JSON.parse(JSON.stringify(supplierList))
        }
      },
      deep: true
    }
  },
  mounted() {
    this.gitList()
  },
  methods: {
    selectableFun(row) {
      return row.stockupState === 0 || row.stockupState === 5
    },
    onExport() {
      // 导出出库单
      const list = []
      this.warehouseList.forEach((m) => {
        if (m.proSerialNumber) {
          m.returnAddress = 1
          list.push(m)
        }
      })
      this.supplierList.forEach((m) => {
        if (m.proSerialNumber) {
          m.returnAddress = 2
          list.push(m)
        }
      })
      if (list.length !== 0) {
        exportSerializableNumber({
          urlCode: this.$store.state.sellDeliverSerial,
          returnGoodsVoList: list
        }).then((res) => {
          downLoadFileBlob(this, res)
        })
      } else {
        this.$message.error('导出序列号不得为空')
      }
    },
    gitList() {
      queryReturnGoodList(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.obj.returnGoodsVoList
          this.forfeiturePenaltys = res.data.obj.financeSetting.confiscateRatio
          let i = 1
          this.list.forEach((m) => {
            m.id = i++
            m.maxs = m.max = m.count
          })
        }
      })
    },
    // 序列号传回来的值
    inProuctSerial(val, i) {
      if (this.typeArr === 1) {
        this.warehouseList[i].proSerialNumber = val
      } else if (this.typeArr === 2) {
        this.supplierList[i].proSerialNumber = val
      }
    },
    // 点击录入
    onEntering(val, i, type) {
      this.typeArr = type
      val.serialCode = val.proSerialNumber
      this.$refs.inProuctSerialCodeRefs.onInitial(
        val,
        i,
        val.proSerialNumber ? 1 : 0
      )
    },
    // 提交
    onApplyForMaintain() {
      if (this.mask) {
        this.$refs.OpenOrCloseRefs.onInitial()
      } else {
        this.$message.error('请填写退货说明！')
      }
    },
    // 确认
    onUpdataState() {
      this.warehouseList.forEach((m) => (m.returnAddress = 1))
      this.supplierList.forEach((m) => (m.returnAddress = 2))
      const params = {
        ocbId: this.$route.query.id,
        returnMark: this.mask,
        returnSaleType: '退货',
        returnGoodsVoList: JSON.parse(JSON.stringify([...this.warehouseList, ...this.supplierList]))
      }
      params.returnGoodsVoList.forEach((m) => {
        m.forfeitureProice = m.forfeitureProice || 0
        m.forfeiturePenalty = m.forfeiturePenalty / 100 || 0
      })
      applyForReturn(params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('已发起退货申请，请等待审批！')
          this.$router.push({
            name: 'contractEdit',
            query: { id: this.$route.query.id, cusId: this.$route.query.cusId }
          })
        }
      })
    },
    changeProice(row) {
      row.forfeiturePenalty = (row.forfeitureProice / row.cbPrice) * 100 || 0
    },
    changePenalty(row) {
      row.forfeitureProice = (row.forfeiturePenalty * row.cbPrice) / 100 || 0
    },
    // 产品移入移出
    onRowClickL(row) {
      if (row.stockupState === 0 || row.stockupState === 5) {
        this.$refs.leftTableRef.toggleRowSelection(row)
      }
    },
    handleSelectionChangeL(val) {
      this.tempList = val
    },
    onImmigration(type) {
      if (this.tempList.length) {
        this.tempList.forEach((ele) => {
          if (type === 1) {
            const i = this.warehouseList.findIndex((m) => m.id === ele.id)
            const n = this.supplierList.findIndex((m) => m.id === ele.id)
            const nums = ele.maxs - (n === -1 ? 0 : this.supplierList[n].count)
            if (n !== -1) {
              this.supplierList[n].max = this.supplierList[n].count
            }
            if (i === -1) {
              ele.forfeiturePenalty = this.forfeiturePenaltys * 100
              ele.forfeitureProice = this.forfeiturePenaltys * ele.cbPrice
              ele.max = ele.count = nums
              this.warehouseList.push(ele)
            } else {
              this.warehouseList[i].max = this.warehouseList[i].count = nums
            }
          } else if (type === 2) {
            const i = this.supplierList.findIndex((m) => m.id === ele.id)
            const n = this.warehouseList.findIndex((m) => m.id === ele.id)
            const nums = ele.maxs - (n === -1 ? 0 : this.warehouseList[n].count)
            if (n !== -1) {
              this.warehouseList[n].max = this.warehouseList[n].count
            }
            if (i === -1) {
              ele.forfeiturePenalty = ele.forfeitureProice = 0
              ele.max = ele.count = nums
              this.supplierList.push(ele)
            } else {
              this.supplierList[i].max = this.supplierList[i].count = nums
            }
          }
          const i = this.list.findIndex((m) => m.id === ele.id)
          this.list.splice(i, 1)
        })
        this.$refs.leftTableRef.clearSelection()
      } else {
        this.$message.error('请选中要移入退货区的产品！')
      }
    },
    onRowClickT(row) {
      this.$refs.topTableRef.toggleRowSelection(row)
    },
    handleSelectionChangeT(val) {
      this.tempWarehouseList = val
    },
    onRowClickB(row) {
      this.$refs.bottomTableRef.toggleRowSelection(row)
    },
    handleSelectionChangeB(val) {
      this.tempSupplierList = val
    },
    changeNumberW(row) {
      if (!row.count) {
        row.count = 0
        this.tempWarehouseList = [row]
        this.tempSupplierList = []
        this.onRemove()
        return
      }
      const i = this.list.findIndex((m) => m.id === row.id)
      const n = this.supplierList.findIndex((m) => m.id === row.id)
      if (n !== -1) {
        this.supplierList[n].max = row.maxs - row.count
        this.supplierList = JSON.parse(JSON.stringify(this.supplierList))
      }
      const num =
        row.maxs - row.count - (n === -1 ? 0 : this.supplierList[n].count)
      if (num > 0) {
        if (i === -1) {
          const obj = JSON.parse(JSON.stringify(row))
          obj.count = num
          this.list.push(obj)
        } else {
          this.list[i].count = num
        }
      } else if (num === 0) {
        this.list.splice(i, 1)
      }
    },
    changeNumberS(row) {
      if (!row.count) {
        row.count = 0
        this.tempSupplierList = [row]
        this.tempWarehouseList = []
        this.onRemove()
        return
      }
      const i = this.list.findIndex((m) => m.id === row.id)
      const n = this.warehouseList.findIndex((m) => m.id === row.id)
      if (n !== -1) {
        this.warehouseList[n].max = row.maxs - row.count
        this.warehouseList = JSON.parse(JSON.stringify(this.warehouseList))
      }
      const num =
        row.maxs - row.count - (n === -1 ? 0 : this.warehouseList[n].count)
      if (num > 0) {
        if (i === -1) {
          const obj = JSON.parse(JSON.stringify(row))
          obj.count = num
          this.list.push(obj)
        } else {
          this.list[i].count = num
        }
      } else if (num === 0) {
        this.list.splice(i, 1)
      }
    },
    onRemove() {
      if (this.tempWarehouseList.length || this.tempSupplierList.length) {
        if (this.tempWarehouseList.length) {
          this.tempWarehouseList.forEach((ele) => {
            const i = this.list.findIndex((m) => m.id === ele.id)
            const m = this.warehouseList.findIndex((m) => m.id === ele.id)
            const n = this.supplierList.findIndex((m) => m.id === ele.id)
            if (i === -1) {
              ele.count = ele.maxs - (n === -1 ? 0 : this.supplierList[n].count)
              this.list.push(ele)
            } else {
              this.list[i].count =
                this.list[i].maxs - (n === -1 ? 0 : this.supplierList[n].count)
            }
            this.warehouseList.splice(m, 1)
          })
          this.$refs.topTableRef.clearSelection()
        }
        if (this.tempSupplierList.length) {
          this.tempSupplierList.forEach((ele) => {
            const i = this.list.findIndex((m) => m.id === ele.id)
            const m = this.supplierList.findIndex((m) => m.id === ele.id)
            const n = this.warehouseList.findIndex((m) => m.id === ele.id)
            if (i === -1) {
              ele.count =
                ele.maxs - (n === -1 ? 0 : this.warehouseList[n].count)
              this.list.push(ele)
            } else {
              this.list[i].count =
                this.list[i].maxs - (n === -1 ? 0 : this.warehouseList[n].count)
            }
            this.supplierList.splice(m, 1)
          })
          this.$refs.bottomTableRef.clearSelection()
        }
      } else {
        this.$message.error('请选中要移出退货区的产品！')
      }
    },
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
